import React, { useState, useEffect } from 'react';

import './ToasterNotifications.scss';
import sharedToasterSubject from '../../services/shared.toasterSubject';
import ToasterNotificationEntry from './ToasterNotifications.toast';
import { useSubscription } from '@apollo/client';
import { graphqlSchema } from '../../services/graphql.schema';


export interface PaymentMovementSubscription {
    orderId: string;
    billingId: string;
    amount: number;
    paid: boolean;
    type: 'spei' | 'card' | 'mercadopago';
}

export default function ToasterNotifications() {
    const [notificationSub] = useState(sharedToasterSubject);
    const [toaster, setToaster] = useState<{ type: 'warning' | 'confirm' | 'error', message: string, clearTs?: number, clickToClose?: boolean, id?: string }[]>([]);

    useEffect(() => {
        const subs = notificationSub.subscribe((toast) => {
            toast.id = Math.random().toString(32).split('.')[1];
            setToaster(toaster => toaster.concat([toast]));
            // setCurrentToast(currId => !currId ? toast.id : currId);
        })

        return () => {
            subs.unsubscribe()
        }
    }, [notificationSub])

    useSubscription<{ paymentMovements: PaymentMovementSubscription }>(graphqlSchema.FISCALPOP.PAYMENTS.paymentMovements, {
        onSubscriptionData: ({ subscriptionData }) => {
            const paymentMovements = subscriptionData.data.paymentMovements;
            console.log('paymentMovements noti: ', paymentMovements);
            const typeLabel = paymentMovements.type === 'spei' ? 'SPEI' : (paymentMovements.type === 'card' ? 'Tarjeta' : 'MercadoPago')
            sharedToasterSubject.next({ type: 'confirm', message: `Pago por ${typeLabel} confirmado, créditos abonados por ${(paymentMovements.amount / 100).toFixed(2)} MXN` })
        }
    });

    const onToastDelete = (id: string) => {
        setToaster(toaster => toaster.filter(_t => _t.id !== id))
    }

    return (
        <div id="TOASTER">
            {
                toaster.map((toast) => (
                    <ToasterNotificationEntry
                        {...toast}
                        onDelete={onToastDelete}
                        key={toast.id}
                    />
                ))
            }
        </div>
    )
}